// AMTB Solution Mock Data
import logo from "../components/assets/logo.jpg";

export const companyInfo = {
  name: "AMTB Solution",
  tagline: "IT Services & Solutions",
  address: "Unit 101, Old Airport Road, Oxford, Bengaluru, Karnataka 560008",
  phone: "+91 84319 60546",
  email: "support@amtbsolution.com",
  logo: logo
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Products", path: "/products" },
  { name: "Projects", path: "/projects" },
  { name: "Careers", path: "/careers" },
  { name: "Blogs", path: "/blogs" },
  { name: "Contact", path: "/contact" }
];

export const heroStats = [
  { value: "100+", label: "Projects Delivered" },
  { value: "50+", label: "Happy Clients" },
  { value: "10+", label: "Years Experience" }
];

export const partnerLogos = [
  { name: "AWS", logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" },
  { name: "Google Cloud", logo: "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg" },
  { name: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" },
  { name: "MongoDB", logo: "https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg" },
  { name: "React", logo: "https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg" },
  { name: "Node.js", logo: "https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg" },
  { name: "Python", logo: "https://www.vectorlogo.zone/logos/python/python-icon.svg" },
  { name: "Docker", logo: "https://www.vectorlogo.zone/logos/docker/docker-icon.svg" }
];

export const services = [
  {
    id: 1,
    title: "Web Application Development",
    description: "Custom and scalable web platforms built with modern technologies. We create responsive, fast, and secure web applications tailored to your business needs.",
    icon: "Globe",
    category: "Software Development"
  },
  {
    id: 2,
    title: "Mobile App Development",
    description: "Native and cross-platform Android & iOS applications. We build intuitive mobile experiences that engage users and drive business growth.",
    icon: "Smartphone",
    category: "Software Development"
  },
  {
    id: 3,
    title: "SaaS Product Development",
    description: "Cloud-based software solutions that scale with your business. We develop robust SaaS platforms with subscription management and multi-tenancy.",
    icon: "Cloud",
    category: "Software Development"
  },
  {
    id: 4,
    title: "AI Tools Development",
    description: "AI-powered automation and intelligent systems. Leverage machine learning and AI to automate processes and gain valuable insights.",
    icon: "Brain",
    category: "Software Development"
  },
  {
    id: 5,
    title: "Cloud Data Management",
    description: "Secure cloud infrastructure setup, data migration services, and optimization. We help you leverage the cloud for scalability and efficiency.",
    icon: "Database",
    category: "Cloud & Data"
  },
  {
    id: 6,
    title: "Team Augmentation",
    description: "Dedicated developers and engineers to extend your team. Get skilled professionals on demand without long-term hiring commitments.",
    icon: "Users",
    category: "IT Resources"
  },
  {
    id: 7,
    title: "SEO & Digital Growth",
    description: "Search engine optimization and website performance enhancement. Improve your online visibility and drive organic traffic to your business.",
    icon: "TrendingUp",
    category: "Digital Services"
  },
  {
    id: 8,
    title: "Technical Consulting",
    description: "Expert IT consulting and support services. We help you make informed technology decisions and implement best practices.",
    icon: "MessageSquare",
    category: "IT Resources"
  }
];

export const saasProducts = [
  {
    id: 1,
    name: "Virtual SIM Platform",
    description: "Manage multiple virtual phone numbers for business communications. Perfect for marketing campaigns and customer support.",
    icon: "Phone",
    features: ["Multiple Virtual Numbers", "SMS & Call Management", "Analytics Dashboard"]
  },
  {
    id: 2,
    name: "Invoice Management System",
    description: "Streamline your billing with automated invoice generation, tracking, and payment reminders.",
    icon: "FileText",
    features: ["Auto-generation", "Payment Tracking", "Multi-currency Support"]
  },
  {
    id: 3,
    name: "Attendance Management System",
    description: "Track employee attendance with biometric integration, leave management, and comprehensive reporting.",
    icon: "Clock",
    features: ["Biometric Integration", "Leave Management", "Real-time Reports"]
  },
  {
    id: 4,
    name: "WhatsApp Automation Platform",
    description: "Automate customer engagement on WhatsApp with chatbots, broadcast messages, and CRM integration.",
    icon: "MessageCircle",
    features: ["Chatbot Builder", "Broadcast Messages", "CRM Integration"]
  },
  {
    id: 5,
    name: "Email Automation Platform",
    description: "Create automated email campaigns with templates, scheduling, and analytics to engage your audience.",
    icon: "Mail",
    features: ["Email Templates", "Campaign Automation", "Analytics & Insights"]
  }
];

export const projects = [
  {
    id: 1,
    title: "E-commerce Platform Development",
    description: "Built a scalable e-commerce platform with inventory management and payment integration.",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400",
    category: "Web Development"
  },
  {
    id: 2,
    title: "Healthcare Management App",
    description: "Mobile application for patient management and appointment scheduling.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400",
    category: "Mobile Development"
  },
  {
    id: 3,
    title: "Cloud Migration Project",
    description: "Migrated legacy systems to AWS cloud infrastructure with zero downtime.",
    image: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?w=400",
    category: "Cloud Solutions"
  },
  {
    id: 4,
    title: "AI-Powered Analytics Dashboard",
    description: "Developed an intelligent analytics platform with predictive insights.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400",
    category: "AI Development"
  },
  {
    id: 5,
    title: "Restaurant Chain POS System",
    description: "Custom POS system for multi-location restaurant chain management.",
    image: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=400",
    category: "SaaS Development"
  },
  {
    id: 6,
    title: "Real Estate Portal",
    description: "Property listing and management platform with virtual tour integration.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400",
    category: "Web Development"
  },
  {
    id: 7,
    title: "Logistics Tracking System",
    description: "Real-time fleet tracking and delivery management solution.",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400",
    category: "Mobile Development"
  },
  {
    id: 8,
    title: "EdTech Learning Platform",
    description: "Online learning management system with video streaming and assessments.",
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=400",
    category: "SaaS Development"
  },
  {
    id: 9,
    title: "FinTech Payment Gateway",
    description: "Secure payment processing solution with multi-currency support.",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400",
    category: "Web Development"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "CEO, TechStart Innovations",
    content: "AMTB Solution transformed our business with their exceptional web development services. Their team delivered a scalable e-commerce platform that increased our sales by 200%.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Founder, HealthPlus",
    content: "The mobile app developed by AMTB Solution revolutionized our patient management system. Their attention to detail and commitment to quality is unmatched.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100"
  },
  {
    id: 3,
    name: "Arun Patel",
    role: "CTO, DataFlow Systems",
    content: "Their cloud migration services were flawless. AMTB Solution helped us move to AWS with zero downtime and reduced our infrastructure costs by 40%.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100"
  },
  {
    id: 4,
    name: "Sneha Reddy",
    role: "Director, EduLearn Academy",
    content: "The SaaS platform AMTB developed for us has transformed how we deliver online education. Their team understood our vision and delivered beyond expectations.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100"
  },
  {
    id: 5,
    name: "Vikram Singh",
    role: "Operations Head, LogiTrack",
    content: "AMTB Solution's logistics tracking system has streamlined our operations significantly. Real-time tracking and automated notifications have improved customer satisfaction.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100"
  }
];

export const faqs = [
  {
    question: "What services does AMTB Solution offer?",
    answer: "We provide end-to-end IT services including web and mobile app development, SaaS product development, AI tools, cloud solutions, team augmentation, and digital marketing services."
  },
  {
    question: "Do you work with startups and SMEs?",
    answer: "Absolutely! We work with businesses of all sizes - from startups to enterprises. Our solutions are scalable and can be tailored to fit your budget and requirements."
  },
  {
    question: "What technologies do you specialize in?",
    answer: "We specialize in modern technologies including React, Node.js, Python, AWS, Google Cloud, MongoDB, PostgreSQL, React Native, Flutter, and various AI/ML frameworks."
  },
  {
    question: "How do you ensure project quality?",
    answer: "We follow agile methodologies with regular sprints, code reviews, automated testing, and continuous integration. Our QA team ensures every deliverable meets the highest standards."
  },
  {
    question: "Do you provide ongoing support and maintenance?",
    answer: "Yes, we offer comprehensive support and maintenance packages including bug fixes, security updates, performance optimization, and feature enhancements."
  },
  {
    question: "What is your project delivery timeline?",
    answer: "Timeline varies based on project complexity. A typical MVP takes 8-12 weeks, while larger projects may take 4-6 months. We provide detailed timelines after requirement analysis."
  }
];

export const careers = [
  {
    id: 1,
    title: "Senior Full Stack Developer",
    location: "Bengaluru, Karnataka",
    type: "Full-time",
    experience: "5+ years",
    description: "We're looking for an experienced Full Stack Developer proficient in React, Node.js, and cloud technologies."
  },
  {
    id: 2,
    title: "Mobile App Developer",
    location: "Bengaluru, Karnataka",
    type: "Full-time",
    experience: "3+ years",
    description: "Join our mobile team to build innovative iOS and Android applications using React Native or Flutter."
  },
  {
    id: 3,
    title: "Cloud Solutions Architect",
    location: "Bengaluru, Karnataka",
    type: "Full-time",
    experience: "6+ years",
    description: "Design and implement scalable cloud infrastructure solutions on AWS/GCP for enterprise clients."
  },
  {
    id: 4,
    title: "UI/UX Designer",
    location: "Bengaluru, Karnataka",
    type: "Full-time",
    experience: "3+ years",
    description: "Create beautiful and intuitive user interfaces for web and mobile applications."
  },
  {
    id: 5,
    title: "Business Development Executive",
    location: "Bengaluru, Karnataka",
    type: "Full-time",
    experience: "2+ years",
    description: "Drive business growth by identifying opportunities and building client relationships."
  }
];

export const blogs = [
  {
    id: 1,
    title: "The Future of AI in Software Development",
    excerpt: "Explore how artificial intelligence is revolutionizing the way we build software applications.",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400",
    date: "July 15, 2025",
    author: "Tech Team",
    category: "AI & Technology"
  },
  {
    id: 2,
    title: "Best Practices for Cloud Migration",
    excerpt: "Learn the essential steps and strategies for a successful cloud migration project.",
    image: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?w=400",
    date: "July 10, 2025",
    author: "Cloud Team",
    category: "Cloud Computing"
  },
  {
    id: 3,
    title: "Building Scalable SaaS Applications",
    excerpt: "Key architecture decisions for building SaaS platforms that scale with your business.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400",
    date: "July 5, 2025",
    author: "Dev Team",
    category: "Development"
  },
  {
    id: 4,
    title: "Mobile App Development Trends 2025",
    excerpt: "Stay ahead with the latest trends and technologies in mobile application development.",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400",
    date: "June 28, 2025",
    author: "Mobile Team",
    category: "Mobile Development"
  },
  {
    id: 5,
    title: "Importance of SEO for Business Growth",
    excerpt: "How search engine optimization can drive organic traffic and increase conversions.",
    image: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=400",
    date: "June 20, 2025",
    author: "Digital Team",
    category: "Digital Marketing"
  },
  {
    id: 6,
    title: "Securing Your Web Applications",
    excerpt: "Essential security practices every developer should implement in web applications.",
    image: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=400",
    date: "June 15, 2025",
    author: "Security Team",
    category: "Security"
  }
];

export const productCategories = [
  "All",
  "Web Development",
  "Mobile Development",
  "SaaS Products",
  "Cloud Solutions",
  "AI Tools"
];
